/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateRoomDto,
  RoomWithBranchResponse,
  RoomsListParams,
  UpdateRoomDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * اتاق‌های کلینیک به ترتیب نمایش. بدون فیلتر، اتاق‌های غیرفعال هم برمی‌گردند.
 * @summary فهرست اتاق‌ها
 */
export const roomsList = (
    params?: RoomsListParams,
 signal?: AbortSignal
) => {


      return apiClient<RoomWithBranchResponse[]>(
      {url: `/api/v1/rooms`, method: 'GET',
        params, signal
    },
      );
    }




export const getRoomsListQueryKey = (params?: RoomsListParams,) => {
    return [
    `/api/v1/rooms`, ...(params ? [params] : [])
    ] as const;
    }


export const getRoomsListQueryOptions = <TData = Awaited<ReturnType<typeof roomsList>>, TError = unknown>(params?: RoomsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoomsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof roomsList>>> = ({ signal }) => roomsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof roomsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomsListQueryResult = NonNullable<Awaited<ReturnType<typeof roomsList>>>
export type RoomsListQueryError = unknown


export function useRoomsList<TData = Awaited<ReturnType<typeof roomsList>>, TError = unknown>(
 params: undefined |  RoomsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomsList>>,
          TError,
          Awaited<ReturnType<typeof roomsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomsList<TData = Awaited<ReturnType<typeof roomsList>>, TError = unknown>(
 params?: RoomsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomsList>>,
          TError,
          Awaited<ReturnType<typeof roomsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomsList<TData = Awaited<ReturnType<typeof roomsList>>, TError = unknown>(
 params?: RoomsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست اتاق‌ها
 */

export function useRoomsList<TData = Awaited<ReturnType<typeof roomsList>>, TError = unknown>(
 params?: RoomsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoomsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * ظرفیت بیش از یک یعنی چند نوبت هم‌زمان می‌توانند این اتاق را اشغال کنند — مثلاً اتاق لیزر با دو تخت.
 * @summary افزودن اتاق
 */
export const roomsCreate = (
    createRoomDto: CreateRoomDto,
 signal?: AbortSignal
) => {


      return apiClient<RoomWithBranchResponse>(
      {url: `/api/v1/rooms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRoomDto, signal
    },
      );
    }




export const getRoomsCreateMutationKey = () => ['roomsCreate'] as const;

export const getRoomsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomsCreate>>, TError,RoomsCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof roomsCreate>>, TError,RoomsCreateMutationVariables, TContext> => {

const mutationKey = getRoomsCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roomsCreate>>, RoomsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  roomsCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RoomsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof roomsCreate>>>
    export type RoomsCreateMutationBody = CreateRoomDto
    export type RoomsCreateMutationError = void
    export type RoomsCreateMutationVariables = {data: CreateRoomDto}

    /**
 * @summary افزودن اتاق
 */
export const useRoomsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomsCreate>>, TError,RoomsCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roomsCreate>>,
        TError,
        RoomsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getRoomsCreateMutationOptions(options), queryClient);
    }
    /**
 * @summary یک اتاق
 */
export const roomsGet = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<RoomWithBranchResponse>(
      {url: `/api/v1/rooms/${id}`, method: 'GET', signal
    },
      );
    }




export const getRoomsGetQueryKey = (id: string,) => {
    return [
    `/api/v1/rooms/${id}`
    ] as const;
    }


export const getRoomsGetQueryOptions = <TData = Awaited<ReturnType<typeof roomsGet>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRoomsGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof roomsGet>>> = ({ signal }) => roomsGet(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof roomsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RoomsGetQueryResult = NonNullable<Awaited<ReturnType<typeof roomsGet>>>
export type RoomsGetQueryError = void


export function useRoomsGet<TData = Awaited<ReturnType<typeof roomsGet>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomsGet>>,
          TError,
          Awaited<ReturnType<typeof roomsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomsGet<TData = Awaited<ReturnType<typeof roomsGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof roomsGet>>,
          TError,
          Awaited<ReturnType<typeof roomsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRoomsGet<TData = Awaited<ReturnType<typeof roomsGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary یک اتاق
 */

export function useRoomsGet<TData = Awaited<ReturnType<typeof roomsGet>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof roomsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRoomsGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * غیرفعال کردن اتاق آن را از تقویم و رزرو حذف می‌کند ولی سوابق را نگه می‌دارد.
 * @summary ویرایش اتاق
 */
export const roomsUpdate = (
    id: string,
    updateRoomDto: UpdateRoomDto,
 signal?: AbortSignal
) => {


      return apiClient<RoomWithBranchResponse>(
      {url: `/api/v1/rooms/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateRoomDto, signal
    },
      );
    }




export const getRoomsUpdateMutationKey = () => ['roomsUpdate'] as const;

export const getRoomsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomsUpdate>>, TError,RoomsUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof roomsUpdate>>, TError,RoomsUpdateMutationVariables, TContext> => {

const mutationKey = getRoomsUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roomsUpdate>>, RoomsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  roomsUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RoomsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof roomsUpdate>>>
    export type RoomsUpdateMutationBody = UpdateRoomDto
    export type RoomsUpdateMutationError = void
    export type RoomsUpdateMutationVariables = {id: string;data: UpdateRoomDto}

    /**
 * @summary ویرایش اتاق
 */
export const useRoomsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomsUpdate>>, TError,RoomsUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roomsUpdate>>,
        TError,
        RoomsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getRoomsUpdateMutationOptions(options), queryClient);
    }
    /**
 * فقط اتاقی که هیچ نوبت یا خدمتی به آن ثبت نشده حذف می‌شود؛ در غیر این صورت باید غیرفعالش کنید تا سوابق درمانی دست‌نخورده بماند.
 * @summary حذف اتاق
 */
export const roomsRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/rooms/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getRoomsRemoveMutationKey = () => ['roomsRemove'] as const;

export const getRoomsRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomsRemove>>, TError,RoomsRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof roomsRemove>>, TError,RoomsRemoveMutationVariables, TContext> => {

const mutationKey = getRoomsRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof roomsRemove>>, RoomsRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  roomsRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RoomsRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof roomsRemove>>>

    export type RoomsRemoveMutationError = void
    export type RoomsRemoveMutationVariables = {id: string}

    /**
 * @summary حذف اتاق
 */
export const useRoomsRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof roomsRemove>>, TError,RoomsRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof roomsRemove>>,
        TError,
        RoomsRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getRoomsRemoveMutationOptions(options), queryClient);
    }
